import type { ParsedToken } from 'firebase/auth';

/**
 * Single canonical check for the "has Pro access" claim.
 * Accepts all three aliases written by onLoginSetClaims:
 *   isPro  (canonical)
 *   hasPro (legacy alias)
 *   pro    (legacy alias)
 */
export function hasProClaim(claims: ParsedToken | null | undefined): boolean {
  if (!claims) return false;
  return !!(claims.isPro || claims.hasPro || claims.pro);
}

/**
 * True if the user has any admin claim (super or support).
 */
export function hasAdminClaim(claims: ParsedToken | null | undefined): boolean {
  if (!claims) return false;
  return !!(claims.admin);
}

/**
 * Returns the admin role tier, or null if not an admin.
 */
export function getAdminRole(
  claims: ParsedToken | null | undefined
): 'super' | 'support' | null {
  if (!claims || !claims.admin) return null;
  if (claims.role === 'super' || claims.super === true) return 'super';
  if (claims.role === 'support') return 'support';
  return null;
}

/**
 * True if the user is a demo account.
 */
export function isDemoAccount(claims: ParsedToken | null | undefined): boolean {
  if (!claims) return false;
  return !!(claims.demo);
}
